import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.snowflakePushDataToAzure;

const snowflakePushDataToAzureData = createSelector([selector], (state) => state);

export default {
  snowflakePushDataToAzureData
};